import "./attribute-list.scss";
